export const titleCased = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1)

export const lowerCased = (str: string): string => str.toLowerCase()

export const capitalize = (str?: string) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : ''
